/**
 * 自定义组件加载器
 * @authors Harry
 * @date    2018-08-30 14:46:29
 */
import ModalSimple from './modal/modalSimple.vue'
import PackageSize from './other/packageSize.vue'

const components = [ModalSimple, PackageSize]

const install = (Vue) => {
  components.map(cm => {
    Vue.component(cm.name, cm)
  })
}

export default install



// WEBPACK FOOTER //
// ./src/packages/index.js